// 授权两种方式
// 1，同域授权，获取usertoken成功后，存储到localstorage，跳转到业务页面读取即可
// 2，跨域授权（awsbj-game2u.xingyunzhi.cn  h5act.upliveapp.com m.upliveapps.com）
//      获取usertoken后，将其作为参数跳转到业务页面 

import config from './config';
import sns from './sns/index';
import notification from 'c-notification';
import Cache from 'c-cache';
import url from 'c-url';
import ProfileGet from './profile/get';
import ProfileSet from './profile/set';
import lang from './lang/index';
import loading from 'c-loading';
import native from 'c-up-native';

const _system = native.getSystem();
const cache = new Cache({
    prefix: 'uplive'
});
const feature = _system == 'pc' ? 9999 : 8888;
const deviceType = _system == 'pc' ? 'PC' : 'H5';
const version = _system == 'pc' ? '8.8.8' : '9.9.9';

const token = {
    // 获取up用户的usertoken
    get(platform, code, tokenSecret, verifier) {

        let opt = {
            authcode: code,
            feature,
            channel: url.query('channel') || 'h5_default',  
            language: lang.type, // 添加语言
            deviceType,
            version,
        };
        
        opt.channel = opt.channel.substr(0, 20);

        switch (platform) {
            case 'wechat':
                opt.type = 3;
                break;
            case 'facebook':
                opt.type = 4;
                break;
            case 'twitter':
                opt.type = 16;
                opt = Object.assign(opt, {
                    tokenSecret,
                    verifier
                });
                break;
            case 'weibo':
                opt.type = 5;
                opt.callback = location.href;
                break;
            case 'qq':
                opt.type = 2;
                opt.callback = encodeURIComponent(location.href);
                opt.state = 'test';
                break;
            default:
                break;
        }

        if (window.smDeviceId) {
            opt.deviceId = window.smDeviceId;
        }
        
        $.ajax({
            url : config.getUsertokenPath(),
            data : opt,
            type : 'GET',
            dataType : 'json'
        }).done((res)=>{
            $('#wrap').empty();
            
            // 报错
            if (res.code == 'E000002' || res.code == 'E000003') {
                if (platform == 'wechat') {
                    sns.jumpToSNS(platform, 'snsapi_userinfo');
                } else if (platform == 'weibo') {
                    sns.jumpToSNS(platform);
                } else if (platform == 'facebook') {
                    location.reload();
                } else {
                    notification.simple('system error');
                }
            
            } else if (res.code == 'E000001' || res.code == 'E000004') { // 设备被封禁的code = E000005
                
                notification.simple('system error', 100 * 1000);
            } else if (res.code == 'E000005') {

                $(document.body).empty();
                notification.simple('device forbidden', 100 * 1000);

            } else {
                
                localStorage.setItem('uplive/usertoken' , res.userToken);
                cache.setCache('user', res, 8 * 3600 * 1000);
                
                this.user = encodeURIComponent(JSON.stringify(res));
                
                let getProfileCount = 0;
                let _getProfile = (uid)=>{
                    let profile = new ProfileGet(uid);
                    
                    profile.promise.done((data)=>{
                        let countryCode = data.countryCode;
                        
                        if (url.query('ignoreCountryCode')) {
                            this.back();
                        } else {
                            if (!countryCode) {
                                this.setProfile();
                            } else {
                                debugger;
                                this.back();
                            }
                        }
                    }).fail((data)=>{
                        ++getProfileCount;
                        
                        if (getProfileCount > 3){
                            loading.hide();
                            notification.simple(lang.template('获取个人信息失败'), 100 * 1000);
                        } else {
                            _getProfile(uid);
                        }
                    })
                }
                loading.show({
                    text: 'loading'
                });
                _getProfile(res.uid);
            }

        });
    },

    setProfile() {
        // let _lang = lang.type;
        // let countryCode = _lang.split('-')[1].toUpperCase();

        let systemLanguage = navigator.language || navigator.browserLanguage;
        let _systemLanguage = systemLanguage.toLowerCase();

        switch (_systemLanguage) {
            case 'ar':
                systemLanguage = 'ar-EG';
                break;
            case 'vi':
                systemLanguage = 'vi-VN';
                break;
            case 'en':
                systemLanguage = 'en-US';
                break;
            case 'ja':
                systemLanguage = 'ja-JP';
                break;
            case 'zh':
                systemLanguage = 'zh-CN';
                break;
            default:
                break;
        }

        let arr = systemLanguage.split('-');

        if (arr.length > 1) {
            systemLanguage = arr[0] + '-' + arr[1].toUpperCase();
        } else {
            systemLanguage = 'en-GB';
        }

        let countryCode = systemLanguage.split('-')[1].toUpperCase();

        
        let setProfileCount = 0;

        let _setProfile = ()=>{
            let profileset = new ProfileSet({
                countryCode: countryCode
            });

            profileset.promise.then(
                (data)=>{
                    this.back();
                },
                function(){
                    ++setProfileCount;
                    
                    if (setProfileCount > 3) {
                        loading.hide();
                        notification.simple(lang.template('设置国家或地区失败'), 100 * 1000);
                    } else {
                        _setProfile(countryCode);
                    }
                }
            );
        }

        _setProfile();
    },

    back() {
        var target_uri = decodeURIComponent(url.query('target_uri'));
        let crossDomains = [
            'awsbj-game2u.xingyunzhi.cn',
            'h5act.upliveapp.com',
            'mact.upliveapps.com',
            'dev.upliveapps.com',
            'cn.dev.uplivepapps.com',
            'mena.dev.upliveapps.com',
            'web.upliveapps.com',
            'cn.up.live',
            'live.uplive.club',
            'localhost:8000',
            'uplive.appanda.cn', // 微信抗封禁备用域名
			'up.live',
			'www.upliveapp.com',
			'www.uplive.club',
			'www.upliveapps.com',
            'www.uplivekr.com',
            'uplivekr.com',
			'lotteryweb.pengpengla.com',
        ];
        let isCrossDomain = 0;
        crossDomains.forEach((item, inx)=>{
            if (target_uri.indexOf(item) > -1) {
                isCrossDomain = 1;
            }
        });

        if (isCrossDomain) {
            let [before, hashs] = target_uri.split('#');
            let pis = before.indexOf('?') > -1 ? '&' : '?';
            before += (pis + '__user=' + this.user);
            target_uri = before + (hashs ? ('#' + hashs) : '');
        }
        sns.jump(target_uri);
    }
};

export default token;



// WEBPACK FOOTER //
// ./js/token.js